
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/rozhodci/[id]",
      function () {
        return require("private-next-pages/rozhodci/[id].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/rozhodci/[id]"])
      });
    }
  